export const viewFromBase64 = (base64: string): void => {
  const binaryString = window.atob(base64);
  const length = binaryString.length;
  const bytes = new Uint8Array(length);

  for (let i = 0; i < length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  const blob = new Blob([bytes], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);

  // Fallback for iOS - set location.href for in-place navigation
  if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
    window.location.href = url; // Redirect in the same tab
  } else {
    window.open(url); // Open in a new tab for other devices
  }
};
